'use client';
import Panel from "../Panel/index.js";
export default Panel;